module.exports = __webpack_public_path__ + "static/media/trash.5a3ca0aa.svg";